module.exports = __webpack_public_path__ + "static/media/opensans-extrabolditalic-webfont.96e3c241.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-extrabolditalic-webfont.woff2
// module id = 1021
// module chunks = 0